import React from 'react';
import { motion } from 'framer-motion';
import { Unlock, Droplets, Wind } from 'lucide-react';
const steps = [{
  icon: Unlock,
  title: 'Desbloqueo',
  desc: 'Libera las vías digestivas obstruidas suavemente.'
}, {
  icon: Droplets,
  title: 'Drenaje',
  desc: 'Elimina el exceso de agua extracelular retenida.'
}, {
  icon: Wind,
  title: 'Calma',
  desc: 'Expulsa el aire atrapado y desinflama el tejido.'
}];
export function UniqueMechanism() {
  return <section className="py-16 md:py-24 px-4 bg-forest text-white" data-id="element-147">
      <div className="max-w-5xl mx-auto" data-id="element-148">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-149">
          <span className="text-orange-light font-semibold tracking-wider uppercase text-sm mb-4 block" data-id="element-150">
            El Secreto
          </span>
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-151">
            El método de la "Tríada Enzimática"
          </h2>
          <p className="text-lg md:text-xl text-forest-100 max-w-3xl mx-auto leading-relaxed" data-id="element-152">
            Un protocolo de emergencia diseñado para trabajar con la biología de
            tu cuerpo, no en su contra. No es una dieta; es un reseteo mecánico
            y químico de 3 pasos que obliga a tu sistema digestivo a soltar el
            aire atrapado y el exceso de agua extracelular en menos de 24 horas.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-153">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="bg-forest-dark p-8 rounded-3xl border border-forest-light text-center relative overflow-hidden group hover:border-orange transition-colors duration-300" data-id="element-154">
              <div className="absolute top-0 right-0 w-24 h-24 bg-forest-light rounded-bl-full -z-0 opacity-20 group-hover:bg-orange transition-colors duration-300" data-id="element-155"></div>
              <div className="relative z-10" data-id="element-156">
                <div className="w-16 h-16 bg-white/10 rounded-2xl flex items-center justify-center mx-auto mb-6" data-id="element-157">
                  <step.icon className="w-8 h-8 text-orange" data-id="element-158" />
                </div>
                <h3 className="text-2xl font-bold mb-4 font-serif" data-id="element-159">
                  {step.title}
                </h3>
                <p className="text-forest-100" data-id="element-160">{step.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}